import { observer } from 'mobx-react-lite';
import { useStore } from '../../stores/store';
import { Modal, Button, Paper, Typography, Box, useTheme, Backdrop } from '@mui/material';
import UpdateIcon from '@mui/icons-material/Update';

const PwaUpdateNotification = observer(() => {
  const { commonStore } = useStore();
  const theme = useTheme();

  return (
    <Modal
      open={commonStore.updateAvailable}
      disableEscapeKeyDown
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
          sx: {
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
          },
        },
      }}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Paper
        elevation={6}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: '40px 32px',
          borderRadius: '12px',
          background: 'rgba(255, 255, 255, 0.98)',
          backdropFilter: 'blur(10px)',
          maxWidth: '500px',
          width: '90%',
          gap: 3,
          minHeight: '320px',
          justifyContent: 'center',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
          <UpdateIcon sx={{ color: theme.palette.primary.main, fontSize: '36px' }} />
          <Typography variant="h4" fontWeight="bold" color="text.primary">
            Update Available
          </Typography>
        </Box>
        <Typography 
          variant="body1" 
          color="success.main" 
          sx={{
            fontWeight: 600,
            fontSize: '16px',
            textAlign: 'center',
            lineHeight: 1.6,
            px: 2,
          }}
        >
          A new version is available. Please update the app to continue using the latest features and improvements.
        </Typography>
        <Button 
          variant="contained" 
          color="primary" 
          size="large"
          startIcon={<UpdateIcon />}
          onClick={() => commonStore.updateServiceWorker()}
          sx={{
            borderRadius: '8px',
            textTransform: 'none',
            fontWeight: 'bold',
            px: 4,
            py: 1.5,
            mt: 2,
          }}
        >
          Update Now
        </Button>
      </Paper>
    </Modal>
  );
});

export default PwaUpdateNotification;
